import { useEffect, useRef } from 'react';
import { getTimeIndicatorPos } from '../../utils';
import * as S from './styles';

export default function CurrentIndicator() {
  const isCoachMark = localStorage.getItem('coachMark-/home') === 'true';
  const enabledScroll = !isCoachMark;

  const top = enabledScroll ? getTimeIndicatorPos() : -1;
  const currentTimeRef = useRef<HTMLDivElement>(null);
  const firstRender = useRef(true);

  useEffect(() => {
    if (!firstRender.current) return;

    if (enabledScroll) {
      setTimeout(() => {
        currentTimeRef.current?.scrollIntoView({
          block: 'center',
          behavior: 'smooth'
        });
      }, 300);

      firstRender.current = false;
    }
  }, []);

  return <S.Wrapper ref={currentTimeRef} top={top} />;
}
